/*
  Add-on guard: an add-on ("Rush order", "Digital artwork") can't stay in the cart without its product.
  - add-on lines carry properties._addon = "1" and _parent_variant = <variant id of the product they were bought with>;
  - an add-on whose parent variant is no longer in the cart is removed;
  - an add-on without a parent (e.g. added from its own product page) is removed when no regular product is left.
  Runs on page load and after every cart change (theme, cart drawer or apps), then refreshes the drawer / cart page.
*/
(function () {
  var ADDON_VARIANTS = [54317013926216, 54317660537160]; // Rush order, Digital artwork
  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var running = false, timer = null;
  var nativeFetch = window.fetch.bind(window);

  function isAddon(it) {
    var p = it.properties || {};
    return p._addon === '1' || p._addon === 1 || ADDON_VARIANTS.indexOf(it.variant_id) !== -1;
  }

  function orphans(cart) {
    var regular = cart.items.filter(function (it) { return !isAddon(it); });
    return cart.items.filter(function (it) {
      if (!isAddon(it)) return false;
      var parent = it.properties && it.properties._parent_variant;
      if (parent) return !regular.some(function (r) { return String(r.variant_id) === String(parent); });
      return regular.length === 0;
    });
  }

  function refreshUI(cart) {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    nativeFetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (sections && drawer && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents({ sections: sections }); } catch (e) {}
          drawer.classList.toggle('is-empty', cart.item_count === 0);
        }
        if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping(cart.total_price, cart.item_count);
      })
      .catch(function () {});
  }

  function check() {
    if (running) return;
    running = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = orphans(cart);
        if (!bad.length) return;
        var updates = {};
        bad.forEach(function (it) { updates[it.key] = 0; });
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); }).then(refreshUI);
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 400); }

  // Catch cart changes made through fetch (theme, cart drawer, apps)...
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_URL.test(url)) p.then(schedule, function () {});
    return p;
  };
  // ...and the theme's own cart update event.
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    check();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();
